import 'react-app-polyfill/ie11';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

import './design/main.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import TRANSLATIONS_ALB from "./translations/alb/translations.json";
import TRANSLATIONS_EN from "./translations/en/translations.json";

i18next
 .use(LanguageDetector)
 .use(initReactI18next)
 .init({
     interpolation: { escapeValue: false },  // React already does escaping
    lng: 'alb',
    ns: ['translations'],
    defaultNS: 'translations',
    react: {
      useSuspense: false
    },
    fallbackLng: 'alb',
   resources: {
     en: {
       translations: TRANSLATIONS_EN
     },
     alb: {
       translations: TRANSLATIONS_ALB
     }
   }
 });

 i18next.changeLanguage("alb");

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18next}>
    <App />
  </I18nextProvider>
);
